module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-12 form-control-label"
  }, [_vm._v("Преимущества для клиента")]), _vm._v(" "), _c('small', {
    staticClass: "col-12 text-muted"
  }, [_vm._v("Например: «Безналичный расчет»")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAdvantage),
      expression: "newAdvantage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newAdvantage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addAdvantage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAdvantage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    },
    on: {
      "click": _vm.addAdvantage
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.advantages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "advantage_item alert alert-info"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), _c('div', {
      staticClass: "float-right text-info",
      on: {
        "click": function($event) {
          _vm.removeAdvantage(item.id)
        }
      }
    }, [_vm._v("×")])])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-8ad757da"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcInputAdvantages.vue
// module id = 1058
// module chunks = 1